const translations = {}

translations.en = {
  'approval.feedback': 'Give feedback',
  'approve.action.cancel': 'Cancel my reply',
  'approve.action.fix': 'Return',
  'approve.action.next': 'Next',
  'approve.action.no': 'Material(s) must be altered',
  'approve.action.start': 'Start here',
  'approve.action.submit': 'Save replies',
  'approve.action.submitting': 'Saving...',
  'approve.action.yes': 'I approve the materials',
  'approve.consentError': 'Please click marketing permit to continue',
  'approve.consentLabel': 'Marketing permit',
  'approve.consentQuestion':
    'I agree that the material(s) will be used for marketing purposes of the company in question.',
  'approve.errorMessage.default': 'An error has occurred with the system',
  'approve.errorMessage.notFound': 'Page not found',
  'approve.errorMessage.saveError': 'An unexpected error occurred while saving. Please try again.',
  'approve.final.messageError': 'Please comment or approve all the materials!',
  'approve.final.messageSuccess':
    'Thank you for checking the materials. If you approved the materials as they are, we will now deliver them to the orderer. If you asked for alterations to the materials, you will receive the fixed materials to be checked again.',
  'approve.final.messageSuccessClient':
    'Thank you for checking the materials. Once all the project contact persons have approved them, we will deliver them to you to in a downloadable format. If a project contact person asks for alterations to the materials, we will send the fixed materials to be checked again.',
  'approve.header.back': 'Return',
  'approve.header.next': 'Next',
  'approve.material.commentPlaceholder': 'Add your comments to the materials',
  'approve.materialListEmpty': 'Materials have not been uploaded.',
  'approve.materials.articles': 'Articles',
  'approve.materials.files': 'Files',
  'approve.materials.images': 'Photos',
  'approve.materials.videos': 'Videos',
  'approve.materialsSubmitMessage': 'Please remember to save your answers.',
  'approve.messageApproved': 'Your answer has been saved.',
  'approve.messageHasRelated':
    'Note! These materials have been sent to more than one person to approve. If one of them asks for alterations to the materials, they will be sent to be re-checked to every person whose part was altered.',
  'approve.messageIntroClient':
    'Welcome to approve the testimonial materials. You can review and approve the materials at the bottom of the page. Once you have approved them, we will deliver them to you in a downloadable format.',
  'approve.messageIntroDefault':
    'Welcome to approve the testimonial materials. You can review and approve the materials at the bottom of the page. After you have accepted them, they or parts of them can be used by our client in question for their marketing purposes. In addition, they can be published on Kokemuksia.fi website.',
  'approve.messageReopened': 'The same materials have been sent to more than one person to approve.',
  'approve.submittedMessageContent': 'You can now close the tab.',
  'approve.submittedMessageContentApproved':
    'Thank you again for your interview! We hope that the experience has been nice and uncomplicated for you. How did we do? Let us know by answering a short survey. Answering it takes less than a minute.',
  'approve.submittedMessageContentApprovedCustomer':
    'We hope that the process has been nice and uncomplicated for you. How did we do? Let us know by answering a short survey. Answering it takes less than a minute.',
  'approve.submittedMessageContentApprovedLink': 'Answer the survey',
  'approve.submittedMessageTitle': 'Your answers have been saved!',
  'approve.summary': 'Summary:',
  'approve.unsavedChanges': 'Unsaved changes',
  'approve.unsavedChangesPreventPage': "All changes haven't been saved. Are you sure you want to leave?",
  'approve.validationError': 'Please add your comment to the materias that need to be changed.',
  'content.addContent.finnishProduction': 'Finnish content production',
  'content.addContent.globalProduction': 'Global content production',
  'content.addContent.label': 'Send us files',
  'content.addContent.message': 'Message',
  'content.addContent.research': 'Research',
  'content.addContent.submit': 'Send',
  'content.addContent.title': 'Sending files',
  'content.addContent.who': 'To whom are you sending the content to?',
  'content.back': 'Back',
  'content.consent.date': 'Time',
  'content.consent.error': 'An error occurred in searching for marketing permits',
  'content.consent.name': 'Name',
  'content.consent.title': 'Marketing permit',
  'content.group.article': 'Articles',
  'content.group.image': 'Images',
  'content.group.other': 'Other files',
  'content.group.video': 'Videos',
  'content.listTitle': 'Contents',
  'content.materialArticle': 'Article',
  'content.materialFile': 'File',
  'content.materialImage': 'Photo',
  'content.materialPrivate': 'Encrypted file',
  'content.materialType': 'Type',
  'content.materialVideo': 'Video',
  'content.oldMaterialInfo':
    'Contents were previously delivered via Google Drive. Below you can find a link to older content.',
  'content.oldMaterialLink': 'Old content',
  'content.preview': 'Preview content',
  'content.tableDeliveredAt': 'Delivered',
  'content.tableMaterials': 'Contents',
  'content.tableName': 'Name',
  'content.tableUpdatedAt': 'Updated',
  'content.uploadSuccess': 'Thank you, your message/files were sent to our customer support',
  'content.userfolder': 'Added files',
  'content.videoEmbed': 'You can embed the video to your website by copying the script below',
  'content.videoReview.createReview': 'Create video review',
  'content.videoReview.hasReview': 'Video review created',
  'content.videoReview.title': 'Review',
  back: 'Back',
  organizationLoadError: 'Failed to load organization data — some sections may be missing.',
  loginError: 'Passcode invalid',
  loginTitle: 'Open materials',
  loginPlaceholder: 'Passcode...',
  loginButton: 'Save',
  tabContent: 'Content',
  tabWidgets: 'Widgets',
  'widget.tableName': 'Name',
  'widget.tableDate': 'Created',
  'widget.tableEnabled': 'Enabled',
  'widget.newButton': 'New widget',
  'widget.tabGeneral': 'General',
  'widget.tabContent': 'Content',
  'widget.tabSlides': 'Content',
  'widget.tabMedia': 'Media',
  'widget.tabStyling': 'Styling',
  'widget.tabPreview': 'Preview',
  'widget.showPreview': 'Show preview',
  'widget.hidePreview': 'Hide preview',
  'widget.tabEmbed': 'Embed',
  'widget.tabCss': 'CSS',
  'widget.tabStats': 'Statistics',
  'widget.statsImpressions': 'Impressions',
  'widget.statsVideoPlays': 'Video plays',
  'widget.cssInstructions': 'CSS is scoped to the shadow DOM and will not affect the rest of the page.',
  'widget.fieldMedia': 'Media',
  'widget.fieldMediaHint': 'Choose an image from your organization materials.',
  'widget.mediaPlaceholder': 'Select a media file',
  'widget.mediaPrivateHint': 'Private files are linked but cannot be previewed here.',
  'widget.mediaEmpty': 'No images found in your organization materials.',
  'widget.previewVideo': 'Video',
  'widget.imagePositionHint': 'The image is cropped to a 16:9 frame. Drag the image to position it inside the frame.',
  'widget.imagePositionReset': 'Center',
  'widget.sectionColors': 'Colors',
  'widget.fieldAccentColor': 'Accent color',
  'widget.fieldBackgroundColor': 'Background color',
  'widget.sectionGeneral': 'General',
  'widget.fieldLayout': 'Layout',
  'widget.layoutImageText': 'Image + text',
  'widget.layoutTextImage': 'Text + image',
  'widget.fieldMaxWidth': 'Max width (px)',
  'widget.fieldMaxWidthHint': 'Leave empty to let the widget fill the space it is embedded in.',
  'widget.sectionText': 'Text',
  'widget.fieldTitleFontSize': 'Title font size (px)',
  'widget.fieldContentFontSize': 'Content font size (px)',
  'widget.fieldFontSizeHint': 'Leave empty to use the default size.',
  'widget.fieldTitle': 'Title',
  'widget.fieldTitleHint': 'The title of the widget',
  'widget.fieldDomain': 'Domain',
  'widget.fieldDomainHint': 'The widget will only work on this domain.',
  'widget.fieldDescription': 'Description',
  'widget.fieldDescriptionHint': 'The description of the widget',
  'widget.fieldTitleText': 'Title text',
  'widget.fieldContentText': 'Content text',
  'widget.fieldPersonName': 'Person name',
  'widget.fieldPersonTitle': 'Person title',
  'widget.fieldCompany': 'Person company',
  'widget.fieldCtaText': 'CTA text',
  'widget.fieldCtaUrl': 'CTA URL',
  'widget.create': 'Create',
  'widget.cancel': 'Cancel',
  'widget.createError': 'An error occurred. Please try again.',
  'widget.save': 'Save',
  'widget.saveError': 'An error occurred. Please try again.',
  'widget.saveSuccess': 'Saved!',
  'widget.delete': 'Delete',
  'widget.deleteConfirm': 'Confirm delete',
  'widget.embedInstructions': 'Add the code below to your HTML where you want the widget to appear.',
  'widget.copy': 'Copy',
  'widget.copied': 'Copied!',
  'widget.slide': 'Slide',
  'widget.addSlide': 'Add slide',
  back: 'Back',
}

translations.fi = {
  'approval.feedback': 'Anna palautetta',
  'approve.action.cancel': 'Peruuta vastaukseni',
  'approve.action.fix': 'Palaa',
  'approve.action.next': 'Seuraava',
  'approve.action.no': 'Materiaali(t) tarvitsee muutoksia',
  'approve.action.start': 'Aloita tästä',
  'approve.action.submit': 'Tallenna vastaukset',
  'approve.action.submitting': 'Tallennetaan...',
  'approve.action.yes': 'Hyväksyn materiaalit',
  'approve.consentError': 'Hyväksy materiaalien markkinointikäyttö',
  'approve.consentLabel': 'Markkinointilupa',
  'approve.consentQuestion': 'Hyväksyn, että materiaalia käytetään yrityksen markkinointiin',
  'approve.errorMessage.default': 'Järjestelmässä tapahtui virhe',
  'approve.errorMessage.notFound': 'Valittua sivua ei löytynyt',
  'approve.errorMessage.saveError': 'Tallennuksessa tapahtui virhe. Yritä tallentamista uudestaan.',
  'approve.final.messageError': 'Annathan vastauksesi kaikkiin materiaaleihin, kiitos!',
  'approve.final.messageSuccess':
    'Kiitos materiaalien tarkastamisesta. Jos hyväksyit materiaalit sellaisenaan, toimitamme ne seuraavaksi tilaajalle. Jos pyysit materiaaleihin korjauksia, saat muokatut materiaalit korjausten jälkeen uudestaan tarkastettavaksi.',
  'approve.final.messageSuccessClient':
    'Kiitos materiaalien tarkastamisesta. Jos hyväksytte materiaalit sellaisenaan, toimitamme ne teille ladattavassa muodossa heti jokaisen projektiyhteyshenkilön kuitattua ne. Jos joku projektin yhteyshenkilöistä pyytää materiaaleihin korjauksia, lähetämme korjatut versiot teille vielä uudestaan tarkastettavaksi.',
  'approve.header.back': 'Palaa',
  'approve.header.next': 'Seuraava',
  'approve.material.commentPlaceholder': 'Anna kommenttisi materiaaliin',
  'approve.materialListEmpty': 'Aineistoja ei ole ladattu.',
  'approve.materials.articles': 'Artikkelit',
  'approve.materials.files': 'Tiedostoja',
  'approve.materials.images': 'Kuvat',
  'approve.materials.videos': 'Videot',
  'approve.materialsSubmitMessage': 'Muistathan tallentaa vastauksesi.',
  'approve.messageApproved': 'Vastauksesi on tallennettu.',
  'approve.messageHasRelated':
    'Huom! Samat aineistot on lähetetty hyväksyttäväksi useammalle kuin yhdelle henkilölle. Jos joku hyväksyjistä pyytää materiaaleihin muutosta, lähetetään kaikki materiaalit uudestaan tarkistettavaksi kullekin hyväksyjälle, jonka osuutta muutos koskee.',
  'approve.messageIntroClient':
    'Tervetuloa hyväksymään kokemusmateriaaleja. Pääset tutustumaan materiaaleihin ja hyväksymään niitä sivun alareunasta. Toimitamme materiaalit teille ladattavassa muodossa teidän kuitattua ne hyväksytyiksi.',
  'approve.messageIntroDefault':
    'Tervetuloa hyväksymään haastatteluaineistoja. Pääset tutustumaan materiaaleihin ja hyväksymään niitä sivun alareunasta. Hyväksymisenne jälkeen materiaaleja tai osia niistä voidaan käyttää asiakasyrityksemme markkinointitarkoituksiin. Lisäksi ne voidaan julkaista Kokemuksia.fi -verkkosivustolla.',
  'approve.messageReopened': 'Samat aineistot on lähetetty hyväksyttäväksi useammalle kuin yhdelle henkilölle.',
  'approve.submittedMessageContent': 'Voit nyt sulkea selainikkunan.',
  'approve.submittedMessageContentApproved':
    'Kiitos vielä haastattelustasi! Toivottavasti kokemus on ollut sinulle mukava ja mutkaton. Miten onnistuimme? Vastaa lyhyeen kyselyyn. Aikaa vastaaminen vie vain pari minuuttia.',
  'approve.submittedMessageContentApprovedCustomer':
    'Toivottavasti prosessi on ollut sinulle mukava ja mutkaton. Miten onnistuimme? Vastaa lyhyeen kyselyyn. Aikaa vastaaminen vie vain pari minuuttia.',
  'approve.submittedMessageTitle': 'Vastauksesi on tallennettu!',
  'approve.submittedMessageContentApprovedLink': 'Vastaa kyselyyn',
  'approve.summary': 'Yhteenveto:',
  'approve.unsavedChanges': 'Tallentamattomia muutoksia',
  'approve.unsavedChangesPreventPage': 'Kaikkia tietoja ei ole tallennettu, haluatko varmasti jatkaa?',
  'approve.validationError': 'Lisääthän kommenttisi materiaaleihin, jotka tarvitsevat muutoksia.',
  'content.addContent.finnishProduction': 'Suomen sisällöntuotanto',
  'content.addContent.globalProduction': 'Kansainvälinen sisällöntuontanto',
  'content.addContent.label': 'Tiedostot',
  'content.addContent.message': 'Viesti',
  'content.addContent.research': 'Tutkimus',
  'content.addContent.submit': 'Lähetä',
  'content.addContent.title': 'Tiedostojen lähetys',
  'content.addContent.who': 'Kenelle olet toimittamassa?',
  'content.back': 'Takaisin',
  'content.consent.date': 'Aika',
  'content.consent.error': 'Virhe tapahtui kun haettiin markkinointilupia',
  'content.consent.name': 'Nimi',
  'content.consent.title': 'Markkinointilupa',
  'content.group.article': 'Artikkelit',
  'content.group.image': 'Kuvat',
  'content.group.other': 'Muut tiedostot',
  'content.group.video': 'Videot',
  'content.listTitle': 'Sisällöt',
  'content.materialArticle': 'Artikkeli',
  'content.materialFile': 'Tiedosto',
  'content.materialImage': 'Kuva',
  'content.materialPrivate': 'Salattu tiedosto',
  'content.materialType': 'Tyyppi',
  'content.materialVideo': 'Video',
  'content.oldMaterialInfo':
    'Sisällöt toimitettiin aiemmin Google Driven kautta. Alta löydät linkin vanhoihin sisältöihin.',
  'content.oldMaterialLink': 'Vanhat sisällöt',
  'content.preview': 'Esikatsele sisältöä',
  'content.tableDeliveredAt': 'Toimitettu',
  'content.tableMaterials': 'Materiaalit',
  'content.tableName': 'Nimi',
  'content.tableUpdatedAt': 'Päivitetty',
  'content.uploadSuccess': 'Kiitos, viesti/tiedostot on lähetetty asiakaspalveluun',
  'content.userfolder': 'Käyttäjän lisäämät tiedostot',
  'content.videoEmbed': 'Voit upottaa videon sivustollesi kopioimalla allaolevan koodin',
  'content.videoReview.createReview': 'Luo videoarvostelu',
  'content.videoReview.hasReview': 'Videoarvostelu luotu',
  'content.videoReview.title': 'Arvostelu',
  tabContent: 'Aineisto',
  tabWidgets: 'Widgetit',
  'widget.tableName': 'Nimi',
  'widget.tableDate': 'Luotu',
  'widget.tableEnabled': 'Käytössä',
  'widget.newButton': 'Uusi widget',
  'widget.tabGeneral': 'Perustiedot',
  'widget.tabContent': 'Sisältö',
  'widget.tabSlides': 'Sisältö',
  'widget.tabMedia': 'Media',
  'widget.tabStyling': 'Tyylit',
  'widget.tabPreview': 'Esikatselu',
  'widget.showPreview': 'Näytä esikatselu',
  'widget.hidePreview': 'Piilota esikatselu',
  'widget.tabEmbed': 'Upotus',
  'widget.tabCss': 'CSS',
  'widget.tabStats': 'Tilastot',
  'widget.statsImpressions': 'Näyttökerrat',
  'widget.statsVideoPlays': 'Videoiden katselukerrat',
  'widget.cssInstructions': 'CSS on eristetty shadow DOM:iin eikä vaikuta muuhun sivustoon.',
  'widget.fieldMedia': 'Media',
  'widget.fieldMediaHint': 'Valitse kuva yrityksen aineistoista.',
  'widget.mediaPlaceholder': 'Valitse mediatiedosto',
  'widget.mediaPrivateHint': 'Yksityinen tiedosto voidaan liittää widgetiin, mutta sitä ei voi esikatsella tässä.',
  'widget.mediaEmpty': 'Yrityksen aineistoissa ei ole kuvia.',
  'widget.previewVideo': 'Video',
  'widget.imagePositionHint': 'Kuva rajataan 16:9-kuvasuhteeseen. Vedä kuvaa asetellaksesi sen kehyksen sisällä.',
  'widget.imagePositionReset': 'Keskitä',
  'widget.sectionColors': 'Värit',
  'widget.fieldAccentColor': 'Korostusväri',
  'widget.fieldBackgroundColor': 'Taustaväri',
  'widget.sectionGeneral': 'Yleiset',
  'widget.fieldLayout': 'Asettelu',
  'widget.layoutImageText': 'Kuva + teksti',
  'widget.layoutTextImage': 'Teksti + kuva',
  'widget.fieldMaxWidth': 'Maksimileveys (px)',
  'widget.fieldMaxWidthHint': 'Jätä tyhjäksi, jolloin widget täyttää koko upotuskohdan leveyden.',
  'widget.sectionText': 'Teksti',
  'widget.fieldTitleFontSize': 'Otsikon koko (px)',
  'widget.fieldContentFontSize': 'Sisältötekstin koko (px)',
  'widget.fieldFontSizeHint': 'Jätä tyhjäksi, jolloin käytetään oletuskokoa.',
  'widget.fieldTitle': 'Otsikko',
  'widget.fieldDomain': 'Domain',
  'widget.fieldDomainHint': 'Widget toimii vain tällä domainilla.',
  'widget.fieldDescription': 'Kuvaus',
  'widget.create': 'Luo',
  'widget.cancel': 'Peruuta',
  'widget.createError': 'Tapahtui virhe. Yritä uudelleen.',
  'widget.save': 'Tallenna',
  'widget.saveError': 'Tapahtui virhe. Yritä uudelleen.',
  'widget.saveSuccess': 'Tallennettu!',
  'widget.delete': 'Poista',
  'widget.deleteConfirm': 'Vahvista poisto',
  'widget.embedInstructions': 'Lisää alla oleva koodi sivustosi HTML-koodiin haluamaasi kohtaan.',
  'widget.copy': 'Kopioi',
  'widget.copied': 'Kopioitu!',
  'widget.slide': 'Slide',
  'widget.fieldTitleText': 'Otsikkoteksti',
  'widget.fieldContentText': 'Sisältöteksti',
  'widget.fieldPersonName': 'Henkilön nimi',
  'widget.fieldPersonTitle': 'Henkilön titteli',
  'widget.fieldCompany': 'Henkilön yritys',
  'widget.fieldCtaText': 'CTA-teksti',
  'widget.fieldCtaUrl': 'CTA URL',
  'widget.addSlide': 'Lisää',
  organizationLoadError: 'Organisaation tietojen lataus epäonnistui — osa sisällöstä voi puuttua.',
  loginError: 'Pääsykoodi virheellinen',
  loginTitle: 'Avaa aineistot',
  loginPlaceholder: 'Pääsykoodi...',
  loginButton: 'Tallenna',
  back: 'Takaisin',
}

export { translations }
